import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteProvider } from "./context/SiteContext";
import { PublicLayout } from "./components/PublicLayout";
import HomePage from "./pages/HomePage";
const InsightsPage = lazy(() => import("./pages/InsightsPage"));
const ArticlePage = lazy(() => import("./pages/ArticlePage"));
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-sand" />}>
        <Routes>
          <Route path="/" element={<Public><HomePage /></Public>} />
          <Route path="/insights" element={<Public><InsightsPage /></Public>} />
          <Route path="/insights/:slug" element={<Public><ArticlePage /></Public>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Public><HomePage /></Public>} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </SiteProvider>
  );
}

export default App;
